export const LEARNING_TERM_PAGE_SIZE = 20